import { useState } from 'react';

import { Volume } from '~/shared/types/api';

import { dateFilters, getFilterSearchParams } from '../common/helpers';
import UtlizationChart from '../common/UtlizationChart';

export default function Utilization({ volume }: { volume: Volume }) {
  const [dateFilter, setDateFilter] = useState(
    dateFilters.find((f) => f.title === 'Last 3 hours')!
  );

  const qs = new URLSearchParams([
    ...getFilterSearchParams([{ field: 'volumeId', value: volume.volumeId!, op: 'equals' }]),
    ['start_date', dateFilter?.filter.start_date],
    ['end_date', dateFilter?.filter.end_date],
  ]);

  return (
    <UtlizationChart
      activeFilter={dateFilter}
      onSelect={setDateFilter}
      queryString={qs.toString()}
    />
  );
}
